import type { ShopDto, VerifyNewShopDomainDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useInvalidateShopDomains } from "./use-shop-domains";

export default function useAddDomain(
	shop: ShopDto,
	{ showErrorNotification = true }: { showErrorNotification?: boolean } = {},
) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/preferences/notifications/domains",
		{
			invalidate: useInvalidateShopDomains(shop.id),
			notify: { error: showErrorNotification },
			mapVariables: (body: VerifyNewShopDomainDto) => ({
				params: { path: { shopId: shop.id } },
				body,
			}),
		},
	);
}
